import {useController} from 'react-hook-form';
import {useMemo} from 'react';
import {useMasterData} from '../../../../../components/master-data-provider';
import {Pulldown} from '@/features/company-registration/components/pulldown';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';

export function IndustryKbnField() {
  return (
    <FormField.Root name='companyInfo.industryKbnId'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {control, isError} = useFormField();
  const {
    field: {name, onChange, value, ref},
  } = useController({control, name: 'companyInfo.industryKbnId'});

  const masterData = useMasterData();
  const options = useMemo(
    () =>
      masterData?.industryKbn.map((k) => ({
        key: k.name,
        value: k.id.toString(),
      })) ?? [],
    [masterData?.industryKbn],
  );

  return (
    <Pulldown
      ref={ref}
      id={name}
      name={name}
      placeholder='選択してください'
      value={value}
      options={options}
      error={isError}
      aria-describedby={`${name}-error`}
      style={{width: 187}}
      aria-label='業種区分'
      onChange={onChange}
    />
  );
}
